class BinderPullsFacetLayout extends HTMLElement {
  connectedCallback() {
    if (!this.classList.contains('bp-facets-horizontal')) return;
    this.schedule = () => {
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => this.measure());
    };
    this.resizeObserver = new ResizeObserver(this.schedule);
    this.resizeObserver.observe(this);
    this.mutationObserver = new MutationObserver(this.schedule);
    this.mutationObserver.observe(this, { childList: true, subtree: true });
    this.addEventListener('toggle', this.schedule, true);
    document.fonts.ready.then(() => { if (this.isConnected) this.schedule(); });
    this.schedule();
  }

  measure() {
    const wrapper = this.querySelector('#FacetsWrapperDesktop');
    const desktop = this.querySelector(':scope > facet-filters-form');
    const drawer = this.querySelector(':scope > menu-drawer');
    if (!wrapper || !desktop) return;
    const drawerOpen = drawer?.querySelector(':scope > details[open]');
    const wide = window.matchMedia('(min-width: 750px)').matches;
    if (!wide) {
      this.classList.remove('bp-facets-overflow');
      return;
    }
    const controls = Array.from(wrapper.children).filter(node => node.matches('details, h2'));
    const gap = parseFloat(getComputedStyle(wrapper).columnGap) || 0;
    const needed = controls.reduce((width, node) => {
      const style = getComputedStyle(node);
      return width + node.getBoundingClientRect().width + (parseFloat(style.marginLeft) || 0) + (parseFloat(style.marginRight) || 0);
    }, Math.max(0, controls.length - 1) * gap);
    const overflow = Boolean(drawerOpen) || needed > wrapper.clientWidth + 1;
    const changed = overflow !== this.classList.contains('bp-facets-overflow');
    const hadDesktopFocus = desktop.contains(document.activeElement);
    const hadDrawerFocus = drawer?.contains(document.activeElement);
    if (changed && overflow) desktop.querySelectorAll('details[open]').forEach(node => {
      node.open = false;
      node.querySelector('summary')?.setAttribute('aria-expanded', 'false');
    });
    this.classList.toggle('bp-facets-overflow', overflow);
    if (changed && overflow && hadDesktopFocus) drawer?.querySelector('summary')?.focus();
    if (changed && !overflow && hadDrawerFocus) wrapper.querySelector('summary')?.focus();
  }

  disconnectedCallback() {
    cancelAnimationFrame(this.frame);
    this.resizeObserver?.disconnect();
    this.mutationObserver?.disconnect();
    if (this.schedule) this.removeEventListener('toggle', this.schedule, true);
  }
}

if (!customElements.get('bp-facet-layout')) customElements.define('bp-facet-layout', BinderPullsFacetLayout);
